import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { usePageMeta } from "../../hooks/usePageMeta";
import { Hero } from "./Hero/Hero";
import { MarketingSection } from "./MarketingSection/MarketingSection";
import { ValueProps } from "./ValueProps/ValueProps";
import { Quote } from "./Quote/Quote";
import { FeatureCards } from "./FeatureCards/FeatureCards";
import { TextImage } from "./TextImage/TextImage";
import { UserTypes } from "./UserTypes/UserTypes";
import { ProductHero } from "./ProductHero/ProductHero";
import { FeatureGrid } from "./FeatureGrid/FeatureGrid";
import { Quote2 } from "./Quote2/Quote2";
import { FinalCTA } from "./FinalCTA/FinalCTA";

const HOME_SCHEMA = JSON.stringify({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://360plusapp.com/#organization",
      "name": "360 Plus LLC",
      "url": "https://360plusapp.com",
      "logo": "https://360plusapp.com/assets/general/logo-white.svg",
      "sameAs": [
        "https://play.google.com/store/apps/details?id=com.app360plus.mobile",
        "https://apps.apple.com/us/app/360plus/id1571217336",
      ],
    },
    {
      "@type": "SoftwareApplication",
      "@id": "https://360plusapp.com/#app",
      "name": "360PLUS",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "iOS, Android, Web",
      "description": "Construction project management software for transparent, collaborative, and efficient project delivery.",
      "offers": { "@type": "Offer", "price": "0", "priceCurrency": "USD" },
    },
  ],
});

export function Home() {
  const [showContact, setShowContact] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  usePageMeta({
    title: "360PLUS | Industry-Born Construction Project Management",
    description: "360PLUS is transparent construction project management software crafted by industry leaders. Collaborate, report, and manage projects with clarity, simplicity, and exceptional value.",
    canonical: "https://360plusapp.com",
  });

  useEffect(() => {
    document.body.className = showContact ? "contact-page" : "home-page";
    return () => { document.body.className = ""; };
  }, [showContact]);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    script.textContent = HOME_SCHEMA;
    document.head.appendChild(script);
    return () => { document.getElementById("structured-data")?.remove(); };
  }, []);

  function handleContactUs() {
    setShowContact(true);
    setIsMobileMenuOpen(false);
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  function handleLegal() {
    navigate("/terms-of-service");
  }

  function handleMobileMenuToggle() {
    setIsMobileMenuOpen((prev) => !prev);
  }

  return (
    <div className="js-smooth-scroll bg-white" id="page-wrapper">
      <main className="page-wrapper__content">
        <Hero
          showContact={showContact}
          isMobileMenuOpen={isMobileMenuOpen}
          onContactUs={handleContactUs}
          onLegal={handleLegal}
          onMobileMenuToggle={handleMobileMenuToggle}
        />
        {!showContact && (
          <>
            <MarketingSection onContactUs={handleContactUs} />
            <ValueProps />
            <Quote />
            <FeatureCards />
            <TextImage />
            <UserTypes />
            <ProductHero />
            <FeatureGrid />
            <Quote2 />
            <FinalCTA onContactUs={handleContactUs} />
          </>
        )}
      </main>
    </div>
  );
}
